import values from 'lodash/values';
import round from 'lodash/round';
import get from 'lodash/get';
import s from '../selectors';
import units from '../../lib/units';
import numericInput from '../../lib/numericInput';
import updateNumericInput from './updateNumericInput';
import { getEnsuredNumericInput } from '../selectors/inputs';
import { tradeInVehicleTypes } from '../../lib/apiKeys';

/**
 * This makes sure all new mpg are set to at least 10mpg better
 * than trade in vehicle.
 * @param {Number} vehicleIndex Index of vehicle to be updated.
 * @param {Number} value New efficiency value from UI.
 */
export default (vehicleIndex, value) => (dispatch, getState) => {
  const state = getState();
  let mpg = numericInput.parse(value);
  if (s.isMetric(state)) {
    mpg = units.ltPer100KmToMpg(value);
  }

  const update = {
    [`input_footprint_transportation_mpg${vehicleIndex}`]: value,
  };

  values(tradeInVehicleTypes).forEach((vehicleType) => {
    const tradeInIndex = get(state.ui, `tradeInVehicleIndices.${vehicleType}`, 1);
    if (tradeInIndex === vehicleIndex) {
      const apiKey = `input_takeaction_${vehicleType}_vehicle_mpg_new`;
      const newMpg = getEnsuredNumericInput(state, apiKey, units.STANDARD);
      if (mpg + 10 > newMpg) {
        update[apiKey] = s.isMetric(state) ?
          round(units.mpgToLtPer100Km(mpg + 10)) :
          round(mpg + 10);
      }
    }
  });

  updateNumericInput(update, '')(dispatch, getState);
};
